import { render, staticRenderFns } from "./FileTypeModal.vue?vue&type=template&id=040e5bda"
import script from "./FileTypeModal.vue?vue&type=script&lang=js"
export * from "./FileTypeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports